/*
 * @Author: whj
 * @Date: 2021-11-09 10:08:36
 * @Last Modified by: whj
 * @Last Modified time: 2024-07-09 16:46:18
 */

import { API_PATH } from './read-only-config';

mslogin.loginurl = `${API_PATH}/api/login/authorize?m=${Math.random()}&callbackurl=${encodeURIComponent(location.href)}`;

export const http = function (
  { type = 'get', url = '', data = {}, timeout = 5000 },
  cb = null
) {
  var xhr = $.ajax({
    type,
    url: `${API_PATH}${url}`,
    data: type == 'get' ? data : JSON.stringify(data),
    dataType: 'json',
    contentType: 'application/json',
    timeout,
    cache: false,
    // xhrFields: {
    //   withCredentials: true,
    // },
    headers: {
      'link': `${window.location.origin}${window.location.pathname}`,
      'Cache-Control': 'no-cache', // 禁用缓存
      'Authorization': localStorage.getItem('token')
    },
    success(res) {
      // alert(`${url} `+ JSON.stringify(res));
      if (res.code === 401) {
        mslogin.login();
        return;
      }

      cb && cb(res);
    },

    error(xhr, status, error) {
      console.log('请求失败', status, error);
      // alert('请求失败', status, error);
      // alert('网络超时');
    },
  });
};
